import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-rapid-error',
  templateUrl: './rapid-error.component.html',
  styleUrls: ['./rapid-error.component.scss']
})
export class RapidErrorComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RapidErrorComponent>
    ) { }

  closeModal() {
    this.dialogRef.close();
  }
}



